import React, {Component, useState} from "react";

import WithUserData from "../WithUserData";
import PrivacyLegal from "../../../assets/images/privacy_legal.svg";
import HelpChat from "../../../assets/images/help_chat.svg";
import LogoutIcon from "../../../assets/images/logout.svg";
import {Link } from "react-router-dom";
import {MdOutlineArrowBackIos} from "react-icons/md";
import Modal from "../../BrandSignup/Modal";

const Settings = () => {
    const [showFeatureComingSoonPopup, setShowFeatureComingSoonPopup] = useState(false)
    const buttonClassName = "cursor-pointer w-full h-16 border border-black text-gray-900 text-lg rounded-lg flex items-center hover:bg-gray-200 mt-0 sm:mt-3"
    const iconClassName = "h-10";
    return (
        <WithUserData>
            {({ logout }) => {
                return (
                    <div className='w-full h-full flex flex-col justify-between sm:justify-start'>
                        <div className="w-full h-16 flex justify-between items-center mt-6 px-2">
                            <Link
                                to='/account'
                                className="ml-0 cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center mx-auto hover:bg-gray-200"
                            >
                                <div className="w-10 flex items-center justify-center">
                                    <MdOutlineArrowBackIos size={18}/>
                                </div>
                                <span>Back</span>
                            </Link>
                            <div className="text-black text-2xl font-bold mr-10">Settings</div>
                        </div>
                        <div className="w-full sm:mt-20">
                            <div className={`${buttonClassName} mt-6 sm:mt-20`}
                                 onClick={() => {
                                     setShowFeatureComingSoonPopup(true);
                                     setTimeout(() => {
                                         setShowFeatureComingSoonPopup(false)
                                     }, 2500)
                                 }}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={PrivacyLegal} className={iconClassName} alt="PrivacyLegal" />
                                </div>
                                <span>Privacy and legal</span>
                            </div>
                            <div className={`${buttonClassName}`}
                                 onClick={() => {
                                     setShowFeatureComingSoonPopup(true);
                                     setTimeout(() => {
                                         setShowFeatureComingSoonPopup(false)
                                     }, 2500)
                                 }}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={HelpChat} className={iconClassName} alt="chat" />
                                </div>
                                <span>Help chat</span>
                            </div>
                            <div
                                className={`${buttonClassName}`}
                                onClick={logout}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={LogoutIcon} className={iconClassName} alt="Logout" />
                                </div>
                                <span>Log out</span>
                            </div>
                        </div>
                        <Modal isOpenModal={showFeatureComingSoonPopup} light={true}>
                            This functionality will be available soon
                        </Modal>
                    </div>
                )
            }}
        </WithUserData>
    );
}
export default Settings;